/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

// Write something that will inject this stuff from the error_logging_pkg package header.

import axios from 'axios';

class DbTwig
{
  static FatalErrorFloor = 20001;
  static FatalErrorCeiling = 20007;

  GatewayOffline = 20209;

    restAPI = (window.asterionRestAPI !== null ? 
      window.asterionRestAPI + '/dbTwig' : 
      window.location.protocol + '//' + window.location.hostname  + 
        (80 !== window.location.port || 443 !== window.location.port ? ':' + window.location.port : '') + '/dbTwig');
    

  axiosApi = null;
  
  context = null;

  constructor(context)
  {
    this.context = context;

    this.axiosApi = axios.create({baseURL: this.restAPI});
    this.callRestAPI = this.callRestAPI.bind(this);
    this.apiErrorHandler = this.apiErrorHandler.bind(this);
  }

  buildURL(serviceName, path, parameters)
  {
    if (typeof parameters === 'undefined')
      return '/' + serviceName + '/' + path;
    else
      return '/' + serviceName + '/' + path + parameters;
  }

  apiErrorHandler(result, errorMessage)
  {
    switch (result.status)
    {
      case 'httpError':
        this.context.postNotification('error', result.errorMessage);
        return;

      case 'apiError':
        this.context.openErrorModal(errorMessage, result.errorMessage);
        return;

      case 'fatalError':
        this.context.userSession.removeUserSessionData();
        window.location.replace(window.redirectURI);
        return;
        
      default:
        this.context.openErrorModal(errorMessage, result.errorMessage);
        return;
    }
  }

  async callRestAPI(serviceName, entryPoint, data, progressCB)
  {
    var contentType = 'application/json';
    if (undefined !== data && data.constructor.name === 'FormData') contentType = 'multipart/form-data';
    var config = 
    {
      headers: {'Content-Type': contentType},
      method: undefined === data ? 'get' : 'post',
      url:  this.buildURL(serviceName, entryPoint),
      onUploadProgress: progressCB
    }  

    if (null !== this.context.userSession.getSessionId()) config.headers.Authorization = 'Bearer ' + this.context.userSession.getSessionId();
    if (undefined !== data) config.data = data.constructor.name === 'Object' ? JSON.stringify(data) : data;

    var returnData;

    await this.axiosApi(config)
      .then(function (response)
      {
        if (response.headers.has('Content-Type') && response.headers.get('Content-Type') === 'application/json; charset=utf-8')
        {
          returnData = {status: 'success', jsonData: response.data};
        }
        else
          returnData =  {status: 'jsonFailure', errorMessage: 'Invalid content type: ' + response.headers.get('Content-Type')};
      })
      .catch(function (error)
      {
        if (!error.response && !error.request) 
        {
          returnData = {status: 'httpError', errorMessage: 'Lost connection to server - ' + error.message};
          return;
        }
        if (!error.response)
        {
          returnData =  {status: 'httpError', errorMessage: 'Lost connection to server - ' + error.message};
          return;
        } 
        if (error.response.headers.has('Content-Type') && error.response.headers.get('Content-Type') === 'application/json; charset=utf-8')
        {
          if (typeof error.response.data.errorCode === 'undefined') 
          {
            returnData =  {status: 'fatalError'};
            return;
          }

          if (error.response.data.errorCode <= DbTwig.FatalErrorCeiling && error.response.data.errorCode >= DbTwig.FatalErrorFloor)
            returnData =  {status: 'fatalError'};
          else 
            returnData =  {status: 'apiError', ...error.response.data};
        }
        else
          returnData =  {status: 'httpError', errorMessage: "Server response not understood.  Consult the system & framework error logs for further information."};
      });

      return returnData;
  }
}

export default DbTwig